// 种子序号转换为名单索引；超出队伍数的位置保留为轮空。
export function createSeededOrder(
  count: number,
  entrants?: number[],
): number[] {
  const slots = 2 ** Math.ceil(Math.log2(Math.max(2, count)))
  let seeds = [1, 2]
  while (seeds.length < slots) {
    const nextSize = seeds.length * 2
    seeds = seeds.flatMap((seed) => [seed, nextSize + 1 - seed])
  }
  return seeds.map((seed) =>
    seed <= count ? (entrants?.[seed - 1] ?? seed - 1) : seed - 1,
  )
}

export const PRINTABLE_TEAM_COUNTS = [6, 10, 12, 16] as const

export function hasSeededTemplate(count: number | undefined): boolean {
  return PRINTABLE_TEAM_COUNTS.some((value) => value === count)
}
